import "../../../Styles/Sass/exhibitor-template.scss";
import "../../../Styles/Sass/ExhibitorLineModal.scss";
import "../../../Components/Widgets/FeaturedProducts/featuredProductCarousel.js";
import "../../../Components/Widgets/FeaturedProducts/favorite-product.js";

$(document).ready(function () {
    /*TODO: This works but wasn't fully implemented in favor of a separate page. Disable for now...
    $('.featured-products-section .see-more').on('click', function (e) {
        e.preventDefault();

        let nPerPage = 8;
        let pageToGet = $(this).data('page');
        loadProductPage(pageToGet);

        if (nPerPage * pageToGet >= $(this).data('total-count')) {
            $(this).hide(); // hide See More button if we've seen them all
        }
        else {
            $(this).data('page', pageToGet + 1); // otherwise increment next page property
        }
    });
    */

    $('.we-supply-buyers-block .see-more-cats').on('click', function () {
        // TODO
    });

    $(".lines-block").each(function () {
        var $section = $(this);
        var $pillContainer = $section.find(".pill-container");
        var $pillItems = $pillContainer.find(".pill-item");
        var $moreButton = $section.find(".lines-more");
        var initialHeight = 100;

        function updatePillContainer() {
            var initialRows = ($(window).width() < 1024) ? 4 : 3;
            initialHeight = initialRows * $pillItems.outerHeight(true);
            if ($pillContainer.css("max-height") === "none") {
                if ($pillContainer.height() <= initialHeight) {
                    $moreButton.css("display", "none");
                }
                $pillContainer.css("max-height", initialHeight);

                $pillContainer.css("overflow", "hidden");
                $moreButton.text("See More");
            } else {
                $pillContainer.css("max-height", "none");
                $moreButton.text("See Less");

                if ($pillContainer.height() <= initialHeight) {
                    $moreButton.css("display", "none");
                }
            }
        }

        updatePillContainer();
        $moreButton.on("click", function () {
            updatePillContainer();
        });        
    });    

    $(".section.exhibitor-supply").each(function () {
        var $section = $(this);
        var $cardContainer = $section.find(".card-container");
        var $cardItems = $cardContainer.find(".card-item");
        var $moreButton = $section.find(".more");

        var allVisible = true;
        function updateCardContainer() {
            var initialItems = ($(window).width() < 1024) ? 4 : 6;

            if (!allVisible) {
                $moreButton.text("See Less");
                $cardItems.show();
                allVisible = true;
                exhibitorSupplySetupHeight();
            } else {
                if ($cardItems.length > initialItems) {
                    $cardItems.slice(initialItems).hide();
                    $moreButton.text("See More");
                    allVisible = false;
                    exhibitorSupplySetupHeight();
                } else {
                    $moreButton.css("display", "none");
                }
            }
        }

        updateCardContainer();
        $moreButton.on("click", function () {
            updateCardContainer();
        });
        //$(window).on("resize", function () {
        //    $moreButton.css("display", "inline-block");
        //});
    });

    var $ppillContainer = null;
    var $ppillItems = null;
    var $moreButtons = null;
    var initialHeightLine = 100;  
    $(".show-more").hide();
    function updateShowroomPillContainer(ppillContainer, ppillItems, initialHeightLine) {
        var initialRows = ($(window).width() < 1024) ? 4 : 3;
        initialHeightLine = initialRows * ppillItems.outerHeight(true);        
        if (ppillContainer.css("max-height") === "none") {
            if (ppillContainer.height() <= initialHeightLine) {
                $moreButtons.css("display", "none");
            }
            else {
                $moreButtons.css("display", "block");
            }
            ppillContainer.css("max-height", initialHeightLine);
            ppillContainer.css("overflow", "hidden");            
            $moreButtons.text("See More");
        } else {
            ppillContainer.css("max-height", "none");
            $moreButtons.text("See Less");           

            if (ppillContainer.height() <= initialHeightLine) {
                $moreButtons.css("display", "none");
            }
        }
    }  

    $('[data-accordion]').on('down.zf.accordion', function (event, element) {
        var showroomName = $(element).attr("data-attr-showroomname");        
        $ppillContainer = $(".pill-container-" + showroomName);
        $ppillItems = $ppillContainer.find(".pill-item-line-" + showroomName);
        $moreButtons = $(".show-more-" + showroomName); 
        updateShowroomPillContainer($ppillContainer, $ppillItems, initialHeightLine);
    });
    $(".more").on("click", function () {
        var showroomName = $(this).attr("attr-data-showroom");
        $ppillContainer = $(".pill-container-" + showroomName);
        $ppillItems = $ppillContainer.find(".pill-item-line-" + showroomName);
        $moreButtons = $(".show-more-" + showroomName);        
        updateShowroomPillContainer($ppillContainer, $ppillItems, initialHeightLine);
    });


    if ($('#requestAppointmentModal').length) {
        // request appt modal time slot picker
        function initTimeSlotControl() {
            var availableTimesString = $('#availableTimes').val();
            //console.log(availableTimesString);
            var datepickerConfig = {
                controls: ['calendar', 'timegrid'],
                touchUi: true,
                valid: []
            };
            datepickerConfig.valid = eval(availableTimesString);
            //console.log(datepickerConfig);
            $('#appointment-time-slot-selection').mobiscroll().datepicker(datepickerConfig);
        }

        initTimeSlotControl();
        document.addEventListener('FormSectionLoaded', function () {
            // reinit after form reload (in case of error and user needs to use it again)
            initTimeSlotControl();
        });
    }
});

function loadProductPage(pageNum) {
    var exhibitorGuid = $('.exhibitor-page').data('exhibitor-guid');
    let $wrapper = $('.featured-products-section .glide__slides');

    $.ajax({
        dataType: "json",
        url: "/ExhibitorFeaturedProducts/GetFeaturedProductsJson",
        data: { ExhibitorGuid: exhibitorGuid, Page: pageNum },
        success: function (resp) {
            //console.log(resp);
            let html = '';
            resp.forEach(function (product) {
                // TODO: will need to add favorite heart after favoriting is implemented
                let productTitle = product.productName;
                if (product.productLine)
                    productTitle += ' - ' + product.productLine;

                html += `
<div class="glide__slide">
    <div class="block__imageHolder" style="--bg-image: url('${product.productImage}')">
        <img src="${product.productImage}" alt="${product.productImageAlt}" />
    </div>

    <div class="block__upperContainer">
        <h3 class="h3__product">${product.productName}</h3>
        <div class="social-share-wrap">
            <button type="button" class="social-share-button">Share</button>
            <div class="social-button-hider">
                <div class="sharethis-inline-share-buttons"
                    data-title="${productTitle}"
                    data-image="https://${window.location.host + product.productImage}"></div>
            </div>
        </div>
    </div>
    <p class="p__desc">${product.productLine}</p>
</div>
                    `;
            });

            $wrapper.append(html);
            $('.block__featuredProducts > .glide').trigger('glideUpdate');
        }
    });
}

// Hide and Show Lines
$('#exhibitor-category').change(function () {
    var selectedCategory = $(this).val();

    // turn them off first
    $('.exhibitor-lines .pill-item').each(function () {
        $(this).hide();
    });

    // turn only those matching
    $('.exhibitor-lines .pill-item*[data-categories]').each(function () {
        if (selectedCategory === 'all')
        {
            console.log("showing all");
            $(this).show();
            return;
        }

        var categoriesString = $(this).data("categories");
        var categories = categoriesString.trim().split(',');

        for (let i = 0; i < categories.length; i++)
        {
            var categoryname = categories[i].trim();
            if (categoryname.length < 1)
                continue;

            if (categoryname.startsWith(selectedCategory)) {
                console.log('showing ' + categories[i]);
                $(this).show();
                return;
            }
        }
    });
});

$('.pill-item').click(function () {
    $(this).find('.lineModal').css('display', 'block');
});

$('.close').click(function () {
    $(this).closest('.lineModal').css('display', 'none');
});

$(".exibhitor-favorite").on("click", function () {
    var exhibitorid = $(this).attr("data-attr-exhibitor-id");
    var favorite = $(".icon-heart-" + exhibitorid).attr("attr-favorite-exhibitor") == "white" ? true : false;
    $.ajax({
        url: "/favorite/exhibitor",
        type: "POST",
        data: {
            exhibitorID: exhibitorid,
            favoriteExhibitor: favorite
        },
        success: function (result) {
            if (favorite) {
                $(".icon-heart-" + exhibitorid).attr("src", "/images/heart-red.svg");
                $(".icon-heart-" + exhibitorid).attr("attr-favorite-exhibitor", "red");
            }
            else {
                $(".icon-heart-" + exhibitorid).attr("src", "/images/heart-white.svg");
                $(".icon-heart-" + exhibitorid).attr("attr-favorite-exhibitor", "white");
            }
        }
    });
});
